/* eslint-disable react/prop-types */
import { Grid, Box, IconButton } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars
import CloseIcon from "@mui/icons-material/Close";
// import moment from "moment";
import { css, StyleSheet } from "aphrodite";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../../../pages/introduction/CreateIntroduction/CreateIntroductionForm/formFields";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import Modal from "../../Modal/Modal";
import OrganizationStructure from "../../OrganizationStructure/OrganizationStructure";
import Typography from "../Typography/Typography";

import ViewTransferForm from "./Form/ViewTranferForm";
import Styles from "./Styles";

const Style = StyleSheet.create({
  mainBoxStyle: {
    display: "flex",
    gap: "30px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },
});
function TransferForm({
  selectedRow,
  open,
  onClose,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
}) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);

  const getState = async () => {
    const { data } = await IntroductionFormApi.getStates();
    if (data?.length) {
      setStates(data);
      const filteredState = data.find((s) => {
        return s.stateId === Number(selectedRow?.state);
      });
      if (filteredState) {
        setCities(filteredState.cities);
      }
    }
  };

  const getDivision = async () => {
    const { data } = await IntroductionFormApi.getDivisions();
    if (data?.length) {
      setDivisions(data);
      const filteredDivision = data.find((s) => {
        return s.divisionId === Number(selectedRow?.divisionId);
      });
      if (filteredDivision) {
        setSubDivisions(filteredDivision.subDivisions);
      }
    }
  };

  const getTitle = () => {
    if (cameFromFriendTransfer) {
      return "View Friend Form";
    }
    if (cameFromMemberTransfer) {
      return "View Member Form";
    }
    return "View Introduction Form";
  };

  useEffect(() => {
    getState();
    getDivision();
  }, [selectedRow, cameFromFriendTransfer, cameFromMemberTransfer]);

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{
        width: isMobile ? "90%" : "72%",
        maxHeight: "95%",
        overflowY: "auto",
      }}
    >
      <Grid container>
        <Formik
          initialValues={{
            [ORGANIZATION_STRUCTURE_FIELDS.REGION]:
              selectedRow?.targetOrganizationStructure?.targetOrgRegionId,
            [ORGANIZATION_STRUCTURE_FIELDS.ZONE]:
              selectedRow?.targetOrganizationStructure?.targetOrgZoneId,
            [ORGANIZATION_STRUCTURE_FIELDS.AREA]:
              selectedRow?.targetOrganizationStructure?.targetOrgAreaId,
            [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]:
              selectedRow?.targetOrganizationStructure?.targetOrgDistrictId,
            [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]:
              selectedRow?.targetOrganizationStructure?.targetOrgChapterId,
            [NEW_ENTRY_FIELDS.NAME]: selectedRow?.fullName,
            [NEW_ENTRY_FIELDS.ADDRESS_LINE_1]: selectedRow?.addressLine1,
            // [NEW_ENTRY_FIELDS.ADDRESS_LINE_2]: selectedRow?.addressLine2,
            [NEW_ENTRY_FIELDS.CITY]: Number(selectedRow?.city),
            [NEW_ENTRY_FIELDS.STATE]: Number(selectedRow?.state),
            [NEW_ENTRY_FIELDS.PINCODE]: selectedRow?.pincode,
            [NEW_ENTRY_FIELDS.CONTACT_NUMBER]: selectedRow?.mobileNumber,
            [NEW_ENTRY_FIELDS.EMAIL_ADDRESS]: selectedRow?.emailId,
            [NEW_ENTRY_FIELDS.DIVISION]: selectedRow?.divisionId,
            [NEW_ENTRY_FIELDS.SUB_DIVISION]: selectedRow?.subdivisionId,
            [NEW_ENTRY_FIELDS.NATIONALITY_ID]: Number(
              selectedRow?.nationalityId
            ),
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]:
              selectedRow?.introducedByName,
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]:
              selectedRow?.introducedByMobileNumber,
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]:
              selectedRow?.introducedByEmail,
            [NEW_ENTRY_FIELDS.DATE_OF_JOINING]: selectedRow?.dateOfJoining,
            [NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]:
              selectedRow?.parentsMobileNumber,
            [NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]:
              selectedRow?.parentsEmailId,
            [NEW_ENTRY_FIELDS.POSITION]: selectedRow?.positions,
          }}
        >
          {({ values, errors, handleChange, setFieldValue }) => (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <IconButton>
                  <CloseIcon onClick={onClose} sx={Styles.closeIcon} />
                </IconButton>
              </div>
              <Box className={css(Style.mainBoxStyle)}>
                <Grid item md={8} sm={12}>
                  <div
                    style={{ padding: "0px 0px 20px 0px", color: "#8C8C8C" }}
                  >
                    <Typography fontWeight="500" fontSize="20px">
                      {getTitle()}
                    </Typography>
                  </div>
                  <ViewTransferForm
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    cities={cities}
                    states={states}
                    divisions={divisions}
                    subDivisions={subDivisions}
                    setSubDivisions={setSubDivisions}
                    cameFromFriendTransfer={cameFromFriendTransfer}
                    cameFromMemberTransfer={cameFromMemberTransfer}
                  />
                </Grid>
                <Grid item md={4} sm={12}>
                  <OrganizationStructure
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    showZoneLocator={false}
                    disabledOSKeys={[
                      ORGANIZATION_STRUCTURE_FIELDS.AREA,
                      ORGANIZATION_STRUCTURE_FIELDS.ZONE,
                      ORGANIZATION_STRUCTURE_FIELDS.REGION,
                      ORGANIZATION_STRUCTURE_FIELDS.CHAPTER,
                      ORGANIZATION_STRUCTURE_FIELDS.DISTRICT,
                    ]}
                  />
                </Grid>
              </Box>
              {/* <Divider
                sx={{
                  display: "flex",
                  width: "100%",
                  paddingTop: "1%",
                  marginBottom: "30px",
                }}
              /> */}
            </>
          )}
        </Formik>
      </Grid>
    </Modal>
  );
}

export default TransferForm;
